import React from "react";
import { Routes, Route } from "react-router-dom";
import "@/App.css";
import { LanguageProvider, COMPANY, useLang } from "@/lib/i18n";
import { ScrollProgress } from "@/lib/ui";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import SEO from "@/components/site/SEO";
import { Marquee, Stats, About, Services, WhyUs, Partners } from "@/components/site/Sections1";
import { Fleet, FleetPremium, Gallery, Process } from "@/components/site/Sections2";
import { Coverage, Testimonials, Faq, Contact, Footer } from "@/components/site/Sections3";
import FloatingActions from "@/components/site/FloatingActions";
import CookiePolicy from "@/pages/CookiePolicy";
import TermsConditions from "@/pages/TermsConditions";

const HomeSEO = () => {
  const { t } = useLang();
  const desc = t({
    ro: "HEB TEAM TRANS oferă servicii profesionale de transport internațional, logistică și distribuție în întreaga Europă. Siguranță, punctualitate și monitorizare permanentă.",
    en: "HEB TEAM TRANS provides professional international transport, logistics and distribution services across Europe. Safety, punctuality and constant monitoring.",
  });
  return (
    <SEO
      title={t({
        ro: "HEB TEAM TRANS | Transport Internațional de Marfă în Europa",
        en: "HEB TEAM TRANS | International Freight Transport in Europe",
      })}
      description={desc}
      path="/"
      jsonLd={{
        "@context": "https://schema.org",
        "@type": "MovingCompany",
        name: COMPANY.legal,
        description: desc,
        telephone: COMPANY.phone,
        email: COMPANY.email,
        areaServed: "European Union",
        address: { "@type": "PostalAddress", addressLocality: "Dumbrăveni", addressRegion: "Suceava", addressCountry: "RO" },
      }}
    />
  );
};

const Preloader = () => (
  <div data-testid="preloader" className="preloader-overlay">
    <div className="preloader-word">
      <img src={COMPANY.logo} alt="HEB TEAM TRANS SRL" className="h-12 md:h-16 w-auto" style={{ filter: "brightness(0) invert(1)" }} />
    </div>
  </div>
);

function Site() {
  return (
    <div className="relative min-h-screen bg-slate-950 text-slate-100 selection:bg-blue-600">
      <HomeSEO />
      <Preloader />
      <ScrollProgress />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Stats />
        <About />
        <Services />
        <WhyUs />
        <Fleet />
        <FleetPremium />
        <Gallery />
        <Partners />
        <Process />
        <Coverage />
        <Testimonials />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <Routes>
        <Route path="/" element={<Site />} />
        <Route path="/politica-cookies" element={<CookiePolicy />} />
        <Route path="/termeni-si-conditii" element={<TermsConditions />} />
      </Routes>
    </LanguageProvider>
  );
}
